document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM loaded, initializing variety pack selector...");

  // ============================================================
  // SHARED STATE & ELEMENTS
  // ============================================================
  const bundleProductsData = document.getElementById("bundle-products-data");
  if (!bundleProductsData) {
    console.error("Bundle products data not found!");
    return;
  }

  let bundleProducts;
  try {
    bundleProducts = JSON.parse(bundleProductsData.textContent);
    console.log("Bundle products parsed:", bundleProducts);
    
    if (!Array.isArray(bundleProducts) || bundleProducts.length === 0) {
      console.error("Bundle products is not a valid array or is empty");
      return;
    }
  } catch (error) {
    console.error("Failed to parse bundle products:", error);
    return;
  }

  // ============================================================
  // PROGRESSIVE ICON IMAGES: show low-res first, swap to high-res when loaded
  // ============================================================
  (function initProgressiveIcons() {
    const icons = document.querySelectorAll(".variety-pack-icon--progressive[data-src]");
    icons.forEach(function (img) {
      const highResUrl = img.getAttribute("data-src");
      if (!highResUrl) return;
      const preload = new Image();
      preload.onload = function () {
        img.src = highResUrl;
        img.classList.add("loaded");
        img.removeAttribute("data-src");
      };
      preload.src = highResUrl;
    });
  })();

  // ============================================================
  // MODULE 1: QUANTITY SELECTORS (MULTIPLE)
  // ============================================================
  const QuantitySelectors = {
    selectors: [],

    init() {
      console.log("Initializing quantity selectors...");
      console.log("Bundle products:", bundleProducts.length);
      
      bundleProducts.forEach((product, index) => {
        const selector = {
          index: index,
          productHandle: product.handle,
          productId: product.id,
          variant: product.variants[0],
          input: document.getElementById(`quantity-selector-${index}`),
          addText: document.getElementById(`quantity-add-text-${index}`),
          decreaseBtn: document.querySelector(`.quantity-decrease[data-index="${index}"]`),
          increaseBtn: document.querySelector(`.quantity-increase[data-index="${index}"]`),
          iconWrapper: document.querySelector(`.variety-pack-icon-wrapper[data-quantity-index="${index}"]`),
        };

        console.log(`Product ${index} (${product.handle}):`, {
          input: selector.input ? 'found' : 'NOT FOUND',
          addText: selector.addText ? 'found' : 'NOT FOUND',
          decreaseBtn: selector.decreaseBtn ? 'found' : 'NOT FOUND',
          increaseBtn: selector.increaseBtn ? 'found' : 'NOT FOUND',
          iconWrapper: selector.iconWrapper ? 'found' : 'NOT FOUND'
        });

        if (!selector.input) {
          console.error(`Quantity input not found for product ${index}`);
          return;
        }

        this.selectors.push(selector);
        this.attachEventListeners(selector);
        this.updateButtonVisibility(selector);
        this.updateDisplayMode(selector);
        this.updateBadgeQuantity(selector);
      });
      
      console.log(`Initialized ${this.selectors.length} quantity selectors`);
    },

    updateButtonVisibility(selector) {
      if (selector.decreaseBtn && selector.input) {
        const currentValue = parseInt(selector.input.value) || 0;
        if (currentValue <= 0) {
          selector.decreaseBtn.classList.add("hidden");
        } else {
          selector.decreaseBtn.classList.remove("hidden");
        }
      }
    },

    updateDisplayMode(selector) {
      if (!selector.input || !selector.addText) return;
      
      const currentValue = parseInt(selector.input.value) || 0;
      
      if (currentValue === 0) {
        // Show "ADD" text, hide input
        selector.addText.classList.remove("hidden");
        selector.input.classList.add("quantity-input-hidden");
      } else {
        // Show input, hide "ADD" text
        selector.addText.classList.add("hidden");
        selector.input.classList.remove("quantity-input-hidden");
      }
    },

    attachEventListeners(selector) {
      // ADD text click - acts like increase button
      if (selector.addText) {
        selector.addText.addEventListener("click", (e) => {
          e.preventDefault();
          console.log(`ADD text clicked for product ${selector.index}`);
          const currentValue = parseInt(selector.input.value) || 0;
          if (currentValue < 99) {
            const newValue = currentValue + 1;
            selector.input.value = newValue;
            selector.input.setAttribute('value', newValue);
            this.onQuantityChange(selector);
          }
        });
      }

      // Icon wrapper click/touch - acts like increase button
      if (selector.iconWrapper) {
        // Handle both click and touch events for better mobile support
        const handleIconClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log(`Icon wrapper clicked/touched for product ${selector.index}`);
          const currentValue = parseInt(selector.input.value) || 0;
          if (currentValue < 99) {
            const newValue = currentValue + 1;
            selector.input.value = newValue;
            selector.input.setAttribute('value', newValue);
            this.onQuantityChange(selector);
          }
        };
        
        selector.iconWrapper.addEventListener("click", handleIconClick);
        selector.iconWrapper.addEventListener("touchend", handleIconClick);
        // Add cursor pointer style
        selector.iconWrapper.style.cursor = "pointer";
      }

      // Decrease button
      if (selector.decreaseBtn) {
        selector.decreaseBtn.addEventListener("click", (e) => {
          e.preventDefault();
          console.log(`Decrease clicked for product ${selector.index}`);
          const currentValue = parseInt(selector.input.value) || 0;
          console.log(`Current value: ${currentValue}`);
          if (currentValue > 0) {
            const newValue = currentValue - 1;
            console.log(`Setting to: ${newValue}`);
            selector.input.value = newValue;
            selector.input.setAttribute('value', newValue);
            this.onQuantityChange(selector);
          }
        });
      }

      // Increase button
      if (selector.increaseBtn) {
        selector.increaseBtn.addEventListener("click", (e) => {
          e.preventDefault();
          console.log(`Increase clicked for product ${selector.index}`);
          const currentValue = parseInt(selector.input.value) || 0;
          console.log(`Current value: ${currentValue}`);
          if (currentValue < 99) {
            const newValue = currentValue + 1;
            console.log(`Setting to: ${newValue}`);
            selector.input.value = newValue;
            selector.input.setAttribute('value', newValue);
            this.onQuantityChange(selector);
          }
        });
      }

      // Direct input
      if (selector.input) {
        selector.input.addEventListener("input", () => {
          let value = parseInt(selector.input.value) || 0;
          // Ensure value is within bounds
          if (value < 0) value = 0;
          if (value > 99) value = 99;
          selector.input.value = value;
          selector.input.setAttribute('value', value);
          this.onQuantityChange(selector);
        });
        
        // Also handle change event
        selector.input.addEventListener("change", () => {
          let value = parseInt(selector.input.value) || 0;
          if (value < 0) value = 0;
          if (value > 99) value = 99;
          selector.input.value = value;
          selector.input.setAttribute('value', value);
          this.onQuantityChange(selector);
        });
      }
    },

    onQuantityChange(selector) {
      this.updateButtonVisibility(selector);
      this.updateDisplayMode(selector);
      this.updateBadgeQuantity(selector);
      // Notify other modules that quantity changed
      if (typeof PriceUpdater !== "undefined") {
        PriceUpdater.update();
      }
    },

    updateBadgeQuantity(selector) {
      const quantity = parseInt(selector.input.value) || 0;
      const iconWrapper = document.querySelector(
        `.variety-pack-icon-wrapper[data-quantity-index="${selector.index}"]`
      );
      if (iconWrapper) {
        iconWrapper.setAttribute('data-quantity', quantity);
      }
    },

    getTotalQuantity() {
      return this.selectors.reduce((total, selector) => {
        return total + (parseInt(selector.input.value) || 0);
      }, 0);
    },

    getQuantities() {
      return this.selectors.map(selector => ({
        index: selector.index,
        productHandle: selector.productHandle,
        productId: selector.productId,
        variant: selector.variant,
        quantity: parseInt(selector.input.value) || 0,
      }));
    },
  };

  // ============================================================
  // MODULE 2: PRICE CALCULATOR & UPDATER
  // ============================================================
  const PriceUpdater = {
    elements: {
      onetimeRadio: document.getElementById("variety-pack-atc-onetime"),
      subscriptionRadio: document.getElementById("variety-pack-atc-subscription"),
      sellingPlanSelect: document.getElementById("variety-pack-selling_plan_select"),
      onetimePrice: document.getElementById("onetime-price"),
      subscriptionPrice: document.getElementById("subscription-price"),
      subscriptionCompareat: document.getElementById("subscription-compareat"),
      atcMessage: document.getElementById("atc-message"),
      atcQuantity: document.getElementById("atc-quantity"),
      atcPrice: document.getElementById("atc-price"),
    },

    init() {
      console.log("Initializing price updater...");
      this.attachEventListeners();
      
      // Set initial state for dropdown visibility
      if (this.elements.sellingPlanSelect) {
        const selector = this.elements.sellingPlanSelect.closest(".bundle-selling_plan_selector");
        if (selector) {
          // Hide by default, show only if subscription is checked
          if (this.elements.subscriptionRadio && this.elements.subscriptionRadio.checked) {
            selector.classList.add("bundle-selling_plan_selector--open");
          } else {
            selector.classList.remove("bundle-selling_plan_selector--open");
          }
        }
      }
      
      this.update();
    },

    syncSubscriptionLabelAria() {
      const subscriptionLabel = document.querySelector(".subscribe-select .bundle-subscription-label");
      if (subscriptionLabel && this.elements.subscriptionRadio) {
        subscriptionLabel.setAttribute("aria-checked", this.elements.subscriptionRadio.checked ? "true" : "false");
      }
    },

    attachEventListeners() {
      // One-time purchase radio
      if (this.elements.onetimeRadio) {
        this.elements.onetimeRadio.addEventListener("change", () => {
          if (this.elements.onetimeRadio.checked) {
            this.update();
            this.syncSubscriptionLabelAria();
            if (this.elements.sellingPlanSelect) {
              this.elements.sellingPlanSelect
                .closest(".bundle-selling_plan_selector")
                .classList.remove("bundle-selling_plan_selector--open");
            }
          }
        });
      }

      // Subscription radio
      if (this.elements.subscriptionRadio) {
        this.elements.subscriptionRadio.addEventListener("change", () => {
          this.syncSubscriptionLabelAria();
          if (this.elements.subscriptionRadio.checked) {
            this.update();
            if (this.elements.sellingPlanSelect) {
              this.elements.sellingPlanSelect
                .closest(".bundle-selling_plan_selector")
                .classList.add("bundle-selling_plan_selector--open");
              // Move focus to frequency select so keyboard users can change it immediately
              requestAnimationFrame(() => {
                this.elements.sellingPlanSelect.focus();
              });
            }
          }
        });
      }

      // Keyboard: allow selecting subscription via Enter/Space when focus is on the label
      const subscriptionLabel = document.querySelector(".subscribe-select .bundle-subscription-label");
      if (subscriptionLabel) {
        subscriptionLabel.addEventListener("keydown", (e) => {
          if (e.key !== "Enter" && e.key !== " ") return;
          e.preventDefault();
          if (subscriptionLabel.getAttribute("aria-disabled") === "true") return;
          const radio = subscriptionLabel.querySelector('input[type="radio"]');
          if (radio && !radio.disabled) {
            radio.click();
            // After selecting subscription, focus the frequency select so it's immediately usable via keyboard
            const sellingPlanSelect = document.getElementById("variety-pack-selling_plan_select");
            if (sellingPlanSelect) {
              requestAnimationFrame(() => {
                sellingPlanSelect.focus();
              });
            }
          }
        });
      }

      // Selling plan select
      if (this.elements.sellingPlanSelect) {
        this.elements.sellingPlanSelect.addEventListener("change", () => {
          console.log(
            "Selling plan changed to:",
            this.elements.sellingPlanSelect.value
          );
          this.update();
        });
      }
    },

    calculatePrices(quantity) {
      // Base price per box: $50 (5000 cents)
      const basePrice = 5000;
      
      // One-time purchase discount per box based on quantity
      let onetimeDiscount;
      if (quantity === 0 || quantity === 1) {
        onetimeDiscount = 0;
      } else if (quantity === 2) {
        onetimeDiscount = 600; // $6 discount
      } else if (quantity === 3) {
        onetimeDiscount = 800; // $8 discount
      } else { // 4+ boxes
        onetimeDiscount = 1100; // $11 discount
      }
      
      // Subscription discount per box based on quantity
      let subscriptionDiscount;
      if (quantity === 0 || quantity === 1) {
        subscriptionDiscount = 0;
      } else if (quantity === 2) {
        subscriptionDiscount = 1100; // $11 discount
      } else if (quantity === 3) {
        subscriptionDiscount = 1300; // $13 discount
      } else { // 4+ boxes
        subscriptionDiscount = 1600; // $16 discount
      }
      
      // Calculate total prices
      const pricePerBoxOnetime = basePrice - onetimeDiscount;
      const pricePerBoxSubscription = basePrice - subscriptionDiscount;
      
      const oneTimePrice = pricePerBoxOnetime * quantity;
      const subscriptionPrice = pricePerBoxSubscription * quantity;

      console.log("Calculated prices:", {
        quantity,
        basePrice: basePrice / 100,
        onetimeDiscount: onetimeDiscount / 100,
        subscriptionDiscount: subscriptionDiscount / 100,
        pricePerBoxOnetime: pricePerBoxOnetime / 100,
        pricePerBoxSubscription: pricePerBoxSubscription / 100,
        oneTimePrice: oneTimePrice / 100,
        subscriptionPrice: subscriptionPrice / 100,
      });

      return { oneTimePrice, subscriptionPrice };
    },

    formatMoney(cents) {
      return "$" + Math.round(cents / 100);
    },

    update() {
      const totalQuantity = QuantitySelectors.getTotalQuantity();
      const prices = this.calculatePrices(totalQuantity);

      if (!prices) return;

      const { oneTimePrice, subscriptionPrice } = prices;
      const formattedOneTimePrice = this.formatMoney(oneTimePrice);
      const formattedSubscriptionPrice = this.formatMoney(subscriptionPrice);

      // Update one-time price
      if (this.elements.onetimePrice) {
        this.elements.onetimePrice.textContent = formattedOneTimePrice;
      }

      // Update subscription prices
      if (totalQuantity > 1) {
        if (this.elements.subscriptionCompareat) {
          this.elements.subscriptionCompareat.innerHTML =
            '<span aria-hidden="true">' + formattedOneTimePrice + "</span>";
          this.elements.subscriptionCompareat.setAttribute(
            "aria-label",
            "Previous price " + formattedOneTimePrice
          );
          this.elements.subscriptionCompareat.style.display = "inline";
        }

        const subscriptionPriceElement =
          this.elements.subscriptionPrice ||
          document.querySelector(".bundle-subscription");
        if (subscriptionPriceElement) {
          subscriptionPriceElement.textContent = formattedSubscriptionPrice;
          subscriptionPriceElement.style.fontStyle = "normal";
          subscriptionPriceElement.style.color = "#212322";
          subscriptionPriceElement.classList.remove("nav-link");
          subscriptionPriceElement.style.margin = "";
        }
      } else {
        if (this.elements.subscriptionCompareat) {
          this.elements.subscriptionCompareat.style.display = "none";
          this.elements.subscriptionCompareat.removeAttribute("aria-label");
        }

        if (this.elements.subscriptionPrice) {
          this.elements.subscriptionPrice.textContent = "*2 box minimum";
          this.elements.subscriptionPrice.style.color = "#212322";
          this.elements.subscriptionPrice.classList.add("nav-link");
          this.elements.subscriptionPrice.style.lineHeight = "20px";
          this.elements.subscriptionPrice.style.margin = "0";
        }
      }

      // Update subscription radio state
      this.updateSubscriptionAvailability(totalQuantity);

      // Update main button
      const isSub =
        this.elements.subscriptionRadio &&
        this.elements.subscriptionRadio.checked;
      if (this.elements.atcPrice) {
        this.elements.atcPrice.textContent = isSub
          ? formattedSubscriptionPrice
          : formattedOneTimePrice;
      }
      if (this.elements.atcMessage) {
        this.elements.atcMessage.textContent = isSub
          ? "Subscribe"
          : "Add to cart";
      }
      
      // Update quantity display
      if (this.elements.atcQuantity) {
        const boxText = totalQuantity === 1 ? "Box" : "Boxes";
        this.elements.atcQuantity.textContent = `(${totalQuantity} ${boxText})`;
      }

      // Update button state based on total quantity
      this.updateButtonState(totalQuantity);
    },

    updateSubscriptionAvailability(quantity) {
      const subscribeSelectRow = document.querySelector(".subscribe-select");
      const subscriptionLabel = document.querySelector(
        ".subscribe-select label"
      );

      if (subscribeSelectRow) {
        if (quantity < 2) {
          if (subscriptionLabel) {
            subscriptionLabel.classList.add("disabled");
            subscriptionLabel.setAttribute("tabindex", "0");
            subscriptionLabel.setAttribute("aria-disabled", "true");
          }
          if (this.elements.subscriptionRadio) {
            this.elements.subscriptionRadio.disabled = true;
            this.elements.subscriptionRadio.setAttribute("tabindex", "-1");
            if (this.elements.onetimeRadio) {
              this.elements.onetimeRadio.checked = true;
            }
          }
        } else {
          if (subscriptionLabel) {
            subscriptionLabel.classList.remove("disabled");
            subscriptionLabel.setAttribute("tabindex", "0");
            subscriptionLabel.removeAttribute("aria-disabled");
          }
          if (this.elements.subscriptionRadio) {
            this.elements.subscriptionRadio.disabled = false;
            this.elements.subscriptionRadio.setAttribute("tabindex", "-1");
          }
          this.syncSubscriptionLabelAria();
        }
      }
    },

    updateButtonState(quantity) {
      const atcButton = document.getElementById("variety-pack-atc");
      if (atcButton) {
        if (quantity === 0) {
          atcButton.disabled = true;
          atcButton.style.opacity = "0.5";
          atcButton.style.cursor = "not-allowed";
        } else {
          atcButton.disabled = false;
          atcButton.style.opacity = "1";
          atcButton.style.cursor = "pointer";
        }
      }
    },
  };

  // ============================================================
  // MODULE 3: ADD TO CART
  // ============================================================
  const AddToCart = {
    elements: {
      button: document.getElementById("variety-pack-atc"),
      error: document.getElementById("variety-pack-atc-error"),
    },

    // Get bundle ID based on purchase type.
    // One-time: single bundle. Subscription: suffix with number from plan name (e.g. 15, 30 for "15 days", "30 days").
    getBundleId(isSubscription, frequencyNumber) {
      let bundleId;
      if (isSubscription && frequencyNumber != null && frequencyNumber !== '') {
        bundleId = 'bundle_sub_' + String(frequencyNumber);
      } else if (isSubscription) {
        bundleId = 'bundle_sub';
      } else {
        bundleId = 'bundle_onetime';
      }
      console.log(`Using ${isSubscription ? 'subscription' : 'one-time'} bundle ID:`, bundleId);
      return bundleId;
    },

    init() {
      console.log("Initializing add to cart...");
      if (!this.elements.button) {
        console.error("Add to cart button not found!");
        return;
      }
      this.attachEventListeners();
    },

    attachEventListeners() {
      this.elements.button.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleAddToCart();
      });
    },

    restoreButtonStructure() {
      // Restore button HTML structure
      this.elements.button.innerHTML = `
        <span class="atc-message" id="atc-message">Add to cart</span>
        <span class="atc-quantity" id="atc-quantity">(0 Boxes)</span> •
        <span class="atc-price" id="atc-price">$0</span>
      `;
      // Re-cache the elements since we replaced the innerHTML
      PriceUpdater.elements.atcMessage = document.getElementById("atc-message");
      PriceUpdater.elements.atcQuantity = document.getElementById("atc-quantity");
      PriceUpdater.elements.atcPrice = document.getElementById("atc-price");
      // Update with current prices
      PriceUpdater.update();
    },

    handleAddToCart() {
      console.log("Add to cart clicked!");
      
      const quantities = QuantitySelectors.getQuantities();
      const totalQuantity = QuantitySelectors.getTotalQuantity();

      if (totalQuantity === 0) {
        console.log("No items selected");
        return;
      }

      const isSubscription =
        PriceUpdater.elements.subscriptionRadio &&
        PriceUpdater.elements.subscriptionRadio.checked;

      // Get the selected selling plan NAME (not ID) - we'll look up the ID per product
      let selectedPlanName = document.getElementById(
        "variety-pack-selling_plan_select"
      )?.value;
      
      // Clean up selectedPlanName - remove any quotes or whitespace
      if (selectedPlanName) {
        selectedPlanName = selectedPlanName.trim().replace(/^["']|["']$/g, '');
        console.log('Selected Plan Name:', selectedPlanName);
      }

      // Hide previous errors
      if (this.elements.error) {
        this.elements.error.style.display = "none";
      }

      // Show loading state
      this.elements.button.disabled = true;
      this.elements.button.innerHTML = "<span>Adding...</span>";

      // Extract number from plan name (e.g. "15 days", "30 days" -> 15, 30) for bundle ID
      const frequencyNumber = selectedPlanName && selectedPlanName.match(/\d+/) ? selectedPlanName.match(/\d+/)[0] : null;

      // Get or create session-specific bundle ID (one-time vs subscription; subscriptions keyed by frequency number from plan name)
      const bundleId = this.getBundleId(isSubscription, frequencyNumber);

      // Prepare cart items - one for each product with quantity > 0
      const items = quantities
        .filter(q => q.quantity > 0)
        .map(q => {
          const product = bundleProducts[q.index];
          const variant = product.variants[0];
          
          // Get the variety-pack-item element for this product to read data attributes
          const productItem = document.querySelector(`.variety-pack-item[data-product-index="${q.index}"]`);
          
          let sellingPlanGroups = product.selling_plan_groups || [];
          let servings = "";
          let icon = "";
          
          // Format variant selling plans to match bundle-selector structure
          // This should be an array of objects with id and sellingPlans properties
          let variantSellingPlans = product.variants.map((v) => {
            return {
              id: v.id,
              sellingPlans: v.selling_plan_allocations || [],
            };
          });
          
          // Try to get data from data attributes if available (more reliable)
          if (productItem) {
            try {
              const sellingPlanGroupsAttr = productItem.getAttribute('data-selling-plan-groups');
              if (sellingPlanGroupsAttr && sellingPlanGroupsAttr !== 'null' && sellingPlanGroupsAttr !== '') {
                sellingPlanGroups = JSON.parse(sellingPlanGroupsAttr);
              }
            } catch (e) {
              console.warn('Could not parse selling plan groups:', e);
            }
            
            servings = productItem.getAttribute('data-serving') || "";
            icon = productItem.getAttribute('data-bundle-icon') || "";
          }
          
          // Fallback to product object if data attributes weren't available
          if (!servings) {
            servings = product.selected_or_first_available_variant?.metafields?.custom?.serving_size || "";
          }
          if (!icon && product.metafields?.custom?.bundle_icon?.value) {
            icon = product.metafields.custom.bundle_icon.value;
          }

          // Find the correct selling plan ID for THIS product based on the selected plan name
          let productSellingPlanId = null;
          if (isSubscription && selectedPlanName) {
            // Look through this product's variant selling plans
            // variantSellingPlans structure: [{ id: variantId, sellingPlans: [selling_plan_allocations] }]
            if (variantSellingPlans && Array.isArray(variantSellingPlans)) {
              // Find the variant entry that matches our current variant
              const variantEntry = variantSellingPlans.find(v => v.id === variant.id);
              if (variantEntry && variantEntry.sellingPlans) {
                const matchingPlan = variantEntry.sellingPlans.find(plan => plan.selling_plan?.name === selectedPlanName);
                if (matchingPlan) {
                  productSellingPlanId = matchingPlan.selling_plan?.selling_plan_id || matchingPlan.selling_plan_id;
                } else {
                  console.warn(`Could not find selling plan "${selectedPlanName}" for product ${q.index} (${q.productHandle})`);
                }
              }
            }
            
            // Fallback: try to find in selling_plan_groups
            if (!productSellingPlanId && sellingPlanGroups && Array.isArray(sellingPlanGroups)) {
              for (const group of sellingPlanGroups) {
                if (group.selling_plans && Array.isArray(group.selling_plans)) {
                  const matchingPlan = group.selling_plans.find(plan => plan.name === selectedPlanName);
                  if (matchingPlan) {
                    productSellingPlanId = matchingPlan.id;
                    break;
                  }
                }
              }
            }
          }

          const itemData = {
            id: variant.id,
            quantity: q.quantity,
            ...(isSubscription &&
              productSellingPlanId && {
                selling_plan: `${productSellingPlanId}`,
              }),
            properties: {
              _isHoliday: false,
              _bundle: bundleId,
              _bundle_icon: icon,
              _selling_plan_groups: sellingPlanGroups,
              _variant_selling_plans: variantSellingPlans,
              _serving: servings,
            },
          };

          console.log(`Product ${q.index} (${q.productHandle}) cart data:`, {
            variantId: variant.id,
            quantity: q.quantity,
            servings,
            icon,
            isSubscription,
            selectedPlanName,
            productSellingPlanId,
            foundPlan: !!productSellingPlanId,
            willAddSellingPlan: isSubscription && !!productSellingPlanId,
            actualSellingPlan: itemData.selling_plan,
            hasSellingPlanGroups: sellingPlanGroups.length > 0,
            hasVariantSellingPlans: variantSellingPlans.length > 0,
            variantSellingPlansStructure: variantSellingPlans,
            availablePlans: variantSellingPlans 
              ? variantSellingPlans
                  .flatMap(v => v.sellingPlans.map(sp => sp.selling_plan?.name || 'unnamed'))
                  .filter(Boolean)
                  .join(', ') 
              : 'none'
          });

          return itemData;
        });

      if (items.length === 0) {
        console.error("No items to add to cart");
        this.restoreButtonStructure();
        this.elements.button.disabled = false;
        return;
      }

      if (isSubscription && !selectedPlanName) {
        console.error("No selling plan selected for subscription");
        if (this.elements.error) {
          this.elements.error.textContent = "Please select a subscription frequency.";
          this.elements.error.style.display = "block";
        }
        this.restoreButtonStructure();
        this.elements.button.disabled = false;
        return;
      }

      // Validate that all subscription items have a selling plan
      if (isSubscription) {
        const itemsWithoutPlan = items.filter(item => !item.selling_plan);
        if (itemsWithoutPlan.length > 0) {
          console.error(`${itemsWithoutPlan.length} items missing selling plan:`, itemsWithoutPlan);
          if (this.elements.error) {
            this.elements.error.textContent = "Some products don't support the selected subscription plan.";
            this.elements.error.style.display = "block";
          }
          this.restoreButtonStructure();
          this.elements.button.disabled = false;
          return;
        }
      }

      const cartData = { items };

      const cartWasEmpty =
        typeof window.isMinicartEmptyVisible === "function" &&
        window.isMinicartEmptyVisible();

      console.log("Adding to cart:", {
        isSubscription,
        selectedPlanName,
        itemCount: items.length,
        items: items.map(item => ({
          variantId: item.id,
          quantity: item.quantity,
          hasSelling_plan: !!item.selling_plan,
          selling_plan: item.selling_plan,
          hasProperties: !!item.properties
        }))
      });
      
      // Add to cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Added to cart successfully:", data);

          if (typeof window.minicartLoadingAfterAddFromEmpty === "function") {
            window.minicartLoadingAfterAddFromEmpty(cartWasEmpty);
          }
          if (typeof cartDraw === "function") cartDraw();
          if (typeof openCart === "function") openCart();

          // Show success
          this.elements.button.innerHTML = "<span>Added!</span>";
          setTimeout(() => {
            this.elements.button.disabled = false;
            this.restoreButtonStructure();
          }, 2000);
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);

          if (typeof window.hideMinicartLoadingOverlay === "function") {
            window.hideMinicartLoadingOverlay();
          }

          if (this.elements.error) {
            this.elements.error.textContent =
              "Error adding to cart. Please try again.";
            this.elements.error.style.display = "block";
          }

          this.elements.button.disabled = false;
          this.restoreButtonStructure();
        });
    },
  };

  // ============================================================
  // INITIALIZE ALL MODULES
  // ============================================================
  QuantitySelectors.init();
  PriceUpdater.init();
  AddToCart.init();

  console.log("Variety pack selector initialized successfully");
});

